import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5","key":"svg-0"}],["path",{"d":"M6 8h4l-2 8","key":"svg-1"}]]

const IconNumber73Small = createReactComponent('outline', 'number-73-small', 'Number73Small', __iconNode);

export default IconNumber73Small;